import React, { useState, useEffect } from 'react'
import { Section, Image } from 'newComponents'
import './styles.scss'

const BlogPostSideBar = (props) => {
  const { active, isSidebar, isBottom, link, image } = props

  if (!active || !image?.url || !link) return null

  const getUtm = () => {
    if (isSidebar) return 'blog_cta_side'
    if (isBottom) return 'blog_cta_bottom'
    return 'blog_cta_top'
  }

  const utm = getUtm()

  if (isSidebar) {
    return (
      <Section className="blog-cta side-bar" noWrapper>
        <a data-blogutm={utm} className="blog-cta-link" href={link} target="_blank" rel="noreferrer">
          <Image className="blog-cta-image" image={image} />
        </a>
      </Section>
    )
  }

  return (
    <Section className="blog-cta">
      <a data-blogutm={utm} className="blog-cta-link" href={link} target="_blank" rel="noreferrer">
        <Image className="blog-cta-image" image={image} />
      </a>
    </Section>
  )
}

export default BlogPostSideBar
